import React from 'react';
import './FormRadioList.scss';
import { FormRadio } from '../FormRadio';
export const FormRadioList = ({ options, title, onChange, value, disabled = false, radioName, }) => (React.createElement("ul", { className: "radio-buttons" },
    React.createElement("div", { className: "radio-buttons__title" }, title),
    options.map((option) => (React.createElement("li", null,
        React.createElement(FormRadio, { radioName: radioName, label: option, onChange: onChange, isChecked: option === value, disabled: disabled }))))));
//# sourceMappingURL=FormRadioList.js.map